import React, {useState} from 'react';
import {WithRouterProps} from 'react-router';
import appStore from 'client/AppStore';

import {FILTER_OPTION, FilterOption} from './StudentSkillPath.types';
import {useStudentSkillPath} from './useStudentSkillPath';
import {BadgesAchieved} from './BadgesAchieved';
import {StudentSkillPathList} from './StudentSkillPathList';
import {StudentSkillPathDropdown} from './StudentSkillPathDropdown';
import classNames from 'classnames';

export function StudentSkillPath({params}: WithRouterProps) {
  const classroomId: string | undefined = params?.classroomId;
  const [selectedFilter, setSelectedFilter] = useState<FilterOption>(FILTER_OPTION.TO_DO);

  const {skillSubjectGroups, badgeCounts, isLoading} = useStudentSkillPath(
    classroomId,
    selectedFilter
  );

  const isMobile = appStore.isMobileView();

  return (
    <div className='student-skill-path flex w-full flex-col'>
      <div
        className={classNames(`flex items-center justify-between py-x3`, {
          'px-x4': !isMobile,
          'px-x2': isMobile
        })}
      >
        <StudentSkillPathDropdown
          selectedFilter={selectedFilter}
          setSelectedFilter={setSelectedFilter}
        />
        <BadgesAchieved badgeCounts={badgeCounts} />
      </div>
      <StudentSkillPathList
        skillSubjectGroups={skillSubjectGroups}
        isLoading={isLoading}
        isMobile={isMobile}
      />
    </div>
  );
}
